export default "__VITE_ASSET__dd83ea7b__"